import { IBaseEventFact, IGapScopedFact } from './common';
import {
  GapAction,
  GapStatus,
} from '@principle-theorem/principle-core/interfaces';

export interface IGapEventFact
  extends IGapScopedFact,
    IBaseEventFact<GapAction, GapStatus> {
  duration: number;
}
